import React from "react";
import { IconMeta } from "./FooterContacts";

export function LinearServicesBento() {
  return (
    <div className="linear-bento-grid">
      {/* Bento Card 1: Multi-Agent Swarms */}
      <div className="bento-card bento-span-2">
        <div className="bento-header">
          <span className="bento-index">FIG 0.1</span>
          <span className="bento-tag">Autonomous Systems</span>
        </div>
        <h3 className="bento-title">Autonomous Agent Swarms &amp; Runtime Orchestration</h3>
        <p className="bento-desc">
          Specialized agent networks executing deterministic state machines with persistent memory,
          strictly typed tool interfaces, and continuous human-in-the-loop authorization gates.
        </p>
        <div className="bento-visual swarm-visual">
          <div className="bento-stat-chip">
            <span className="stat-label">Execution Model</span>
            <span className="stat-val">Deterministic State Graph</span>
          </div>
          <div className="bento-stat-chip">
            <span className="stat-label">Human Gate</span>
            <span className="stat-val">Auditable Approval Hooks</span>
          </div>
          <div className="bento-stat-chip">
            <span className="stat-label">Persistence</span>
            <span className="stat-val">PostgreSQL / Supabase RLS</span>
          </div>
        </div>
      </div>

      {/* Bento Card 2: Meta Cloud API & CRM */}
      <div className="bento-card">
        <div className="bento-header">
          <span className="bento-index">FIG 0.2</span>
          <span className="bento-tag meta-tag">Meta Authenticated</span>
        </div>
        <h3 className="bento-title">Official WhatsApp &amp; CRM Gateways</h3>
        <p className="bento-desc">
          Authenticated Meta Cloud API integration, GoHighLevel multi-account management,
          and webhook verification built for high-throughput enterprise communication.
        </p>
        <div className="bento-meta-badge-box">
          <IconMeta size={24} />
          <div>
            <strong>Official Meta Provider</strong>
            <span>Cloud API · Webhooks · CTWA</span>
          </div>
        </div>
      </div>

      {/* Bento Card 3: Context Engineering */}
      <div className="bento-card">
        <div className="bento-header">
          <span className="bento-index">FIG 0.3</span>
          <span className="bento-tag">Zero Hallucination</span>
        </div>
        <h3 className="bento-title">Deterministic Context Engineering</h3>
        <p className="bento-desc">
          Advanced enterprise RAG, strict JSON schema validation, and real-time evaluation harnesses
          (Langfuse / evals) ensuring zero unverified output reaches customers.
        </p>
        <div className="bento-mini-code">
          <code>eval_gate: passed (100% compliance)</code>
          <code>token_budget: optimized -68%</code>
        </div>
      </div>

      {/* Bento Card 4: High-Performance Voice */}
      <div className="bento-card bento-span-2">
        <div className="bento-header">
          <span className="bento-index">FIG 0.4</span>
          <span className="bento-tag">Low-Latency Audio</span>
        </div>
        <h3 className="bento-title">Voice AI &amp; Multimodal Ingestion Engines</h3>
        <p className="bento-desc">
          Sub-second conversational voice pipelines for automated candidate interviews, SDR qualification,
          and high-fidelity speech-to-text with AssemblyAI.
        </p>
        <div className="bento-voice-metrics">
          <div className="voice-metric">
            <strong>&lt; 500ms</strong>
            <span>Voice Latency</span>
          </div>
          <div className="voice-metric">
            <strong>AssemblyAI</strong>
            <span>Speech-to-Text Standard</span>
          </div>
          <div className="voice-metric">
            <strong>DISC &amp; Graphology</strong>
            <span>Automated Behavioral Profiling</span>
          </div>
        </div>
      </div>
    </div>
  );
}
